import * as React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { Stack } from '@mui/system';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {useState} from 'react'
import SubCard from 'ui-component/cards/SubCard';

const AddMoneyLayout = () => {
    const [Data, setData] = useState({ amount: '', remarks: '' })
    const [open, setOpen] = React.useState(false);
    const[AlertType,setAlertType] = useState('success')
    const[AlertMessage,setAlertMessage] = useState('')

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleChange = (value, name) => {
        setData({ ...Data, [name]: value })
    }

    const handleSubmit = () => {
        if (Data.amount !== '' && Data.remarks !== '') {
            console.log(Data);
        }
        else {
            setAlertMessage('Enter Both the fields')
            setAlertType('error')
            handleClick()
        }
    }

    return (
        <MainCard sx={{ height: '70vh'}} title='Add Money To Wallet'>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical:'top',horizontal:'right'}}>
                <Alert
                    onClose={handleClose}
                    severity={AlertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {AlertMessage}
                </Alert>
            </Snackbar>
            <SubCard sx={{ width: { xl: '50%', lg: '50%', md: '10%%', sm: '100%', xs: '100%' }}}>
            <Stack direction='column' gap={2} >
                <TextField id="outlined-basic" label="Amount" variant="outlined" onChange={(e) => handleChange(e.target.value, 'amount')} />
                <TextField id="outlined-basic" label="Remark" variant="outlined" onChange={(e) => handleChange(e.target.value, 'remarks')} />
                <Button variant='contained' sx={{ backgroundColor: '#A556B2', color: '#fff', "&:hover": { backgroundColor: "#A556B2" } }} onClick={()=>handleSubmit()}>Submit</Button>
            </Stack>
            </SubCard>
        </MainCard>
    )
}

export default AddMoneyLayout